// Define the enum and the array directly
export enum MaterialType {
  CCO = 'CCO',
  QT = 'QT',
  CAST = 'CAST',
  CERAMIC = 'CERAMIC',
  PAN = 'PAN',
}

export const materialTypesData = Object.values(MaterialType);
